export default "/assets/images/mila-room-showcase-03.0195b75d7b16f1e3.webp";